export { default } from "./GeniusVideo";
